import { DatePicker, TimePicker } from 'material-ui-pickers';
import React from 'react';
import ArrowDown from 'utils/images/arrow-down.svg';

const DateSelectorPill = ({ type, value, onChange, className, ...props }) => {
  const PillComponent = props => (
    <div
      onClick={props.onClick}
      className={`date__selector__pill ${className}`}
      style={props.style}
      onChange={onChange}
    >
      <div className="small__label__black">{props.value}</div>
      <div className="date__selector__pill__dropdown__container">
        <img
          className="date__selector__pill__dropdown"
          src={ArrowDown}
          alt="select date"
        />
      </div>
    </div>
  );

  if (type === 'date') {
    return (
      <DatePicker
        value={value}
        onChange={onChange}
        TextFieldComponent={newProps => (
          <PillComponent {...newProps} {...props} />
        )}
      />
    );
  } else {
    return (
      <TimePicker
        minutesStep={60}
        value={value}
        onChange={onChange}
        TextFieldComponent={newProps => (
          <PillComponent {...newProps} {...props} />
        )}
      />
    );
  }
};

export default DateSelectorPill;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/shared/DateSelectorPill.jsx